module.exports = __webpack_public_path__ + "static/media/puntoCadia.c770e073.webp";